import { GeneralService } from 'src/app/services/general.service';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  AbstractControl,
  FormGroup,
  FormBuilder,
  Validators,
} from '@angular/forms';
import { GeneralComponent } from 'src/app/shared/general.component';
import { HttpErrorResponse } from '@angular/common/http';
import { TypeMessage } from 'src/app/entity/enum/enum-notification';
import { DropDownListDTO } from 'src/app/entity/dto/dropdownlist.component';
import { take } from 'rxjs/operators';
import { FormularioService } from 'src/app/services/formulario.service';
import { NotificationService } from 'src/app/services/notification.service';
import { eSiteType } from 'src/app/entity/enum/enum-site-type';
import { eAreaType } from 'src/app/entity/enum/enum-area-type';
import { ActivatedRoute } from '@angular/router';
import { MatSelectChange } from '@angular/material/select';
import { FormAreaTypesService } from './../../../../services/form.area.types.service';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'app-cd001-card-classificacao-I',
  templateUrl: './cd001-card-classificacao-I.component.html',
})
export class Cd001CardClassificacaoIComponent
  extends GeneralComponent
  implements OnInit {
  public formulario?: FormGroup;
  public listHibrido?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
  public listSite?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
  public listProcesso?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
  public listOrigem?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
  public listPeneira?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
  public listDestino?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
  public listPeneiraBruta?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
  public listLoteDs: Array<DropDownListDTO> = new Array<DropDownListDTO>();


  public listHibridoOriginal?: Array<DropDownListDTO> =
    new Array<DropDownListDTO>();
  public listSiteOriginal?: Array<DropDownListDTO> =
    new Array<DropDownListDTO>();
  public listProcessoOriginal?: Array<DropDownListDTO> =
    new Array<DropDownListDTO>();
  public listOrigemOriginal?: Array<DropDownListDTO> =
    new Array<DropDownListDTO>();
  public listPeneiraOriginal?: Array<DropDownListDTO> =
    new Array<DropDownListDTO>();
  public listPeneiraBrutaOriginal?: Array<DropDownListDTO> =
    new Array<DropDownListDTO>();
  public listDestinoOriginal?: Array<DropDownListDTO> =
    new Array<DropDownListDTO>();
  public listGeneration?: Array<DropDownListDTO> = new Array<DropDownListDTO>();

  public listLinhaProcessamento?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
  public listLinhaProcessamentoOriginal?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
  public listClasses?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
  public listClassesOriginal?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
  public listLoteDsOriginal?: Array<DropDownListDTO> = new Array<DropDownListDTO>();

  public listTurno?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
  public listTurnoOriginal?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
  public listLinhaReprocessamentoOriginal?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
  public listLinhaReprocessamento?: Array<DropDownListDTO> = new Array<DropDownListDTO>();

  @Output() mkCalc = new EventEmitter();
  @Output() generationChoose = new EventEmitter();
  @Output() objPC003 = new EventEmitter();
  @Output() mkRequire = new EventEmitter();

  area: string = eAreaType.commercial;
  dropdownLoteds = false;
  disabledInputLoteds = true;
  // tslint:disable-next-line: max-line-length
  constructor(
    protected formularioService: FormularioService,
    protected formBuilder: FormBuilder,
    protected notificationService: NotificationService,
    protected generalService: GeneralService,
    private route: ActivatedRoute
  ) {
    super('Dados da Peneira ou Lote', false);
    if (this.isComercial) {
      //COMERCIAL
      this.formulario = this.formBuilder.group({
        site: [null, []],
        data: [null, [Validators.pattern(this.regexDate)]],
        hora: [null, [Validators.pattern(this.regexHour)]],
        numero_controle: [null, []],
        hibrido: [null, []],
        processo: [null, []],
        lote_origem: [null, []],
        umidade_ds_prc: [null, []],
        // lote_ds: [null, []],
        lote_cs: [null, []],
        origem: [null, []],
        safra: [null, [Validators.required, Validators.pattern(this.regexSafra)]],
        peneira: [null, []],
        destino: [null, []],
        basic: [null, []],
        generation_id: [null, []],
        porcentagem_falha: [null, []],
        vazao: [null, []],
        responsavel_especial: [null, []],
        turno: [null, []],

      })
    } else { //BÁSICA
      this.formulario = this.formBuilder.group({
        site: [null, []],
        data: [null, [Validators.pattern(this.regexDate)]],
        hora: [null, [Validators.pattern(this.regexHour)]],
        numero_controle: [null, []],
        hibrido_rnc: [null, [Validators.required]],
        processo_basica: [null, [Validators.required]],
        umidade_ds_prc: [null, []],
        lote_ds: [{ value: null, disabled: true }, [Validators.required]],
        safra: [null, [Validators.required, Validators.pattern(this.regexSafra)]],
        peneira_basica: [null, [Validators.required]],
        basic: [null, []],
        generation_id: [null, []],
        porcentagem_falha: [null, []],
        vazao: [null, [Validators.required]],
        responsavel_especial: [null, []],
        numero_campo: [null, []],
        linha_processamento: [null, [Validators.required]],
        geracao: [null, [Validators.required]],
        umidade_media: [null, [Validators.required]],
        classe: [null, [Validators.required]],


      })
    }


    this.formulario.controls.basic.disable();
    this.formulario.controls.generation_id.disable();
    this.formulario.controls.porcentagem_falha.disable();
    this.formulario.controls.vazao.disable();
    this.formulario.controls.responsavel_especial.disable();
  }

  public async ngOnInit(): Promise<void> {
    this.getArea();
    this.enableInputs();
    await this.getLists();
    await this.getListGeneration();
    await this.changePeneira();

    this.isBasica
      ? this.formulario.controls['peneira_basica'].valueChanges.subscribe(
        (value) => {
          this.makeRequire();
        }
      )
      : this.formulario.controls['peneira'].valueChanges.subscribe((value) => {
        this.makeCalculations();
      });
    this.isBasica
      ? this.formulario.controls['processo_basica'].valueChanges.subscribe(
        (value) => {
          this.makeRequire();
        }
      )
      : null;
  }

  public changeCollapse(): void {
    this.collapseCard = this.collapseCard ? false : true;
  }

  public hasErrorFormControl(campoFormulario?: AbstractControl): string {
    return this.formularioService.hasErrorFormControl(campoFormulario);
  }

  public makeCalculations() {
    this.mkCalc.emit();
  }

  public makeRequire() {
    this.mkRequire.emit();
  }

  public async getLists(): Promise<void> {
    await Promise.all([
      this.getHibridoDropdown(),
      this.getListSite(),
      this.getDropDownProcesso(),
      this.getListOrigem(),
      this.getDropdownPeneira(),
      this.getListDestino(),
      this.isBasica
        ? this.getListLinhaProcessamentoBasic()
        : null,
      this.isBasica ? this.getListClasseBasic() : null,
      this.isBasica
        ? this.getListPeneiraBrutaBasic()
        : null,
      this.getListTurno(),

    ]);
  }
  async getListLoteDs(safra: string, numeroCampo: string): Promise<void> {
    await this.formularioService.getListDropDownLoteDS(safra, numeroCampo).pipe(take(1)).toPromise().then(response => {
      if (!!response?.data && response.data.length > 0) {
        this.listLoteDs = this.generalService.orderByDropDownList(response.data.map((item, i) => { return { name: item.lote_ds } }) as DropDownListDTO[]);
        this.listLoteDsOriginal = this.listLoteDs;
        this.dropdownLoteds = true;
        this.formulario.get("lote_ds").enable();
        this.formulario.get("lote_ds").updateValueAndValidity();
      }
      else {
        this.listLoteDs = []
        this.dropdownLoteds = false;
        this.formulario.get("lote_ds").enable();
        this.formulario.get("lote_ds").updateValueAndValidity();
      }
    }).catch(async (error: HttpErrorResponse) => {
      this.notificationService.showNotificationError(error, '', TypeMessage.ListErrorPeneira);
    });

  }
  async getListPeneiraBrutaBasic(): Promise<void> {
    await this.formularioService.getListDropDownList('cd001_classificacao', 'peneira_bruta').pipe(take(1)).toPromise().then(response => {
      if (!!response?.data) {
        this.listPeneiraBruta = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
        this.listPeneiraBrutaOriginal = this.listPeneiraBruta;
      }
    }).catch(async (error: HttpErrorResponse) => {
      this.notificationService.showNotificationError(error, '', TypeMessage.ListErrorPeneira);
    });

  }

  async getListLinhaProcessamentoBasic(): Promise<void> {
    await this.formularioService.getListDropDownList('cd001_classificacao', 'linha_processamento').pipe(take(1)).toPromise().then(response => {
      if (!!response?.data) {
        this.listLinhaProcessamento = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
        this.listLinhaProcessamentoOriginal = this.listLinhaProcessamento;
      }
    }).catch(async (error: HttpErrorResponse) => {
      this.notificationService.showNotificationError(error, '', TypeMessage.ListErrorPeneira);
    });
  }

  async getListClasseBasic(): Promise<void> {
    await this.formularioService.getListDropDownList('cd001_classificacao', 'classe_basica').pipe(take(1)).toPromise().then(response => {
      if (!!response?.data) {
        this.listClasses = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
        this.listClassesOriginal = this.listClasses;
      }
    }).catch(async (error: HttpErrorResponse) => {
      this.notificationService.showNotificationError(error, '', TypeMessage.ListErrorPeneira);
    });
  }

  async getListHibrido(): Promise<void> {
    await this.formularioService
      .getListDropDownList('qua007', 'hibrido_rnc')
      .pipe(take(1))
      .toPromise()
      .then((response) => {
        if (!!response?.data) {
          this.listHibrido = this.generalService.orderByDropDownList(
            response.data as DropDownListDTO[]
          );
          this.listHibridoOriginal = this.listHibrido;
        }
      })
      .catch(async (error: HttpErrorResponse) => {
        this.notificationService.showNotificationError(
          error,
          '',
          TypeMessage.ListErrorHibrido
        );
      });
  }

  async getListSite(): Promise<void> {
    this.listSite = this.generalService.getListSiteRecebimento();
    this.listSiteOriginal = this.listSite;
    // await this.formularioService.getListDropDownList('qua007', 'site_origem').pipe(take(1)).toPromise().then(response => {
    //     if (!!response?.data) {
    //         this.listSite = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
    //         this.listSiteOriginal = this.listSite;
    //     }
    // }).catch(async (error: HttpErrorResponse) => {
    //     this.notificationService.showNotificationError(error, '', TypeMessage.ListErrorSiteOrigem);
    // });
  }

  async getListProcesso(area?: string): Promise<void> {
    await this.formularioService
      .getListDropDownList('cd001_classificacao', 'processo', area)
      .pipe(take(1))
      .toPromise()
      .then((response) => {
        if (!!response?.data) {
          this.listProcesso = this.generalService.orderByDropDownList(
            response.data as DropDownListDTO[]
          );
          this.listProcessoOriginal = this.listProcesso;
        }
      })
      .catch(async (error: HttpErrorResponse) => {
        this.notificationService.showNotificationError(
          error,
          '',
          TypeMessage.ListErrorProcesso
        );
      });
  }
  async getListProcessoBasic(area?: string): Promise<void> {
    await this.formularioService
      .getListDropDownList('cd001_classificacao', 'processo_basica')
      .pipe(take(1))
      .toPromise()
      .then((response) => {
        if (!!response?.data) {
          this.listProcesso = this.generalService.orderByDropDownList(
            response.data as DropDownListDTO[]
          );
          this.listProcessoOriginal = this.listProcesso;
        }
      })
      .catch(async (error: HttpErrorResponse) => {
        this.notificationService.showNotificationError(
          error,
          '',
          TypeMessage.ListErrorProcesso
        );
      });
  }

  async getListOrigem(): Promise<void> {
    await this.formularioService
      .getListDropDownList('cd001_classificacao', 'origem')
      .pipe(take(1))
      .toPromise()
      .then((response) => {
        if (!!response?.data) {
          this.listOrigem = this.generalService.orderByDropDownList(
            response.data as DropDownListDTO[]
          );
          this.listOrigemOriginal = this.listOrigem;
        }
      })
      .catch(async (error: HttpErrorResponse) => {
        this.notificationService.showNotificationError(
          error,
          '',
          TypeMessage.ListErrorLoteOrigem
        );
      });
  }

  async getListPeneira(site?: string): Promise<void> {
    await this.formularioService
      .getListDropDownList('cd001_classificacao', 'peneira', site)
      .pipe(take(1))
      .toPromise()
      .then((response) => {
        if (!!response?.data) {
          this.listPeneira = this.generalService.orderByDropDownList(
            response.data as DropDownListDTO[]
          );
          this.listPeneiraOriginal = this.listPeneira;
        }
      })
      .catch(async (error: HttpErrorResponse) => {
        this.notificationService.showNotificationError(
          error,
          '',
          TypeMessage.ListErrorPeneira
        );
      });
  }
  async getListPeneiraBasic(site?: string): Promise<void> {
    await this.formularioService
      .getListDropDownList('cd001_classificacao', 'peneira_basica', site)
      .pipe(take(1))
      .toPromise()
      .then((response) => {
        if (!!response?.data) {
          this.listPeneira = this.generalService.orderByDropDownList(
            response.data as DropDownListDTO[]
          );
          this.listPeneiraOriginal = this.listPeneira;
        }
      })
      .catch(async (error: HttpErrorResponse) => {
        this.notificationService.showNotificationError(
          error,
          '',
          TypeMessage.ListErrorPeneira
        );
      });
  }

  async getListDestino(): Promise<void> {
    await this.formularioService
      .getListDropDownList('cd001_classificacao', 'destino')
      .pipe(take(1))
      .toPromise()
      .then((response) => {
        if (!!response?.data) {
          this.listDestino = this.generalService.orderByDropDownList(
            response.data as DropDownListDTO[]
          );
          this.listDestinoOriginal = this.listDestino;
        }
      })
      .catch(async (error: HttpErrorResponse) => {
        this.notificationService.showNotificationError(
          error,
          '',
          TypeMessage.ListErrorDestino
        );
      });
  }

  async createFilterHibrido(value?: string): Promise<void> {
    if (!!value && value.length > 0) {
      if (
        this.listHibridoOriginal.filter((x) =>
          x.name?.toLowerCase().includes(value?.toLowerCase())
        ).length > 0
      ) {
        this.listHibrido = this.listHibridoOriginal.filter((x) =>
          x.name?.toLowerCase().includes(value?.toLowerCase())
        );
      } else {
        this.listHibrido = this.listHibridoOriginal;
      }
    } else {
      this.listHibrido = this.listHibridoOriginal;
    }
  }

  async createFilterSite(value?: string): Promise<void> {
    if (!!value && value.length > 0) {
      if (
        this.listSiteOriginal.filter((x) =>
          x.name?.toLowerCase().includes(value?.toLowerCase())
        ).length > 0
      ) {
        this.listSite = this.listSiteOriginal.filter((x) =>
          x.name?.toLowerCase().includes(value?.toLowerCase())
        );
      } else {
        this.listSite = this.listSiteOriginal;
      }
    } else {
      this.listSite = this.listSiteOriginal;
    }
  }

  async createFilterProcesso(value?: string): Promise<void> {
    if (!!value && value.length > 0) {
      if (
        this.listProcessoOriginal.filter((x) =>
          x.name?.toLowerCase().includes(value?.toLowerCase())
        ).length > 0
      ) {
        this.listProcesso = this.listProcessoOriginal.filter((x) =>
          x.name?.toLowerCase().includes(value?.toLowerCase())
        );
      } else {
        this.listProcesso = this.listProcessoOriginal;
      }
    } else {
      this.listProcesso = this.listProcessoOriginal;
    }
  }

  async createFilterLinhaProcessamento(value?: string): Promise<void> {
    if (!!value && value.length > 0) {
      if (
        this.listLinhaProcessamentoOriginal.filter((x) =>
          x.name?.toLowerCase().includes(value?.toLowerCase())
        ).length > 0
      ) {
        this.listLinhaProcessamento = this.listLinhaProcessamentoOriginal.filter((x) =>
          x.name?.toLowerCase().includes(value?.toLowerCase())
        );
      } else {
        this.listLinhaProcessamento = this.listLinhaProcessamentoOriginal;
      }
    } else {
      this.listLinhaProcessamento = this.listLinhaProcessamentoOriginal;
    }
  }


  async createFilterOrigem(value?: string): Promise<void> {
    if (!!value && value.length > 0) {
      if (
        this.listOrigemOriginal.filter((x) =>
          x.name?.toLowerCase().includes(value?.toLowerCase())
        ).length > 0
      ) {
        this.listOrigem = this.listOrigemOriginal.filter((x) =>
          x.name?.toLowerCase().includes(value?.toLowerCase())
        );
      } else {
        this.listOrigem = this.listOrigemOriginal;
      }
    } else {
      this.listOrigem = this.listOrigemOriginal;
    }
  }

  async createFilterPeneira(value?: string): Promise<void> {
    if (!!value && value.length > 0) {
      if (
        this.listPeneiraOriginal.filter((x) =>
          x.name?.toLowerCase().includes(value?.toLowerCase())
        ).length > 0
      ) {
        this.listPeneira = this.listPeneiraOriginal.filter((x) =>
          x.name?.toLowerCase().includes(value?.toLowerCase())
        );
      } else {
        this.listPeneira = this.listPeneiraOriginal;
      }
    } else {
      this.listPeneira = this.listPeneiraOriginal;
    }
  }

  async createFilterClasses(value?: string): Promise<void> {
    if (!!value && value.length > 0) {
      if (
        this.listClassesOriginal.filter((x) =>
          x.name?.toLowerCase().includes(value?.toLowerCase())
        ).length > 0
      ) {
        this.listClasses = this.listClassesOriginal.filter((x) =>
          x.name?.toLowerCase().includes(value?.toLowerCase())
        );
      } else {
        this.listClasses = this.listClassesOriginal;
      }
    } else {
      this.listClasses = this.listClassesOriginal;
    }
  }

  async createFilterDestino(value?: string): Promise<void> {
    if (!!value && value.length > 0) {
      if (
        this.listDestinoOriginal.filter((x) =>
          x.name?.toLowerCase().includes(value?.toLowerCase())
        ).length > 0
      ) {
        this.listDestino = this.listDestinoOriginal.filter((x) =>
          x.name?.toLowerCase().includes(value?.toLowerCase())
        );
      } else {
        this.listDestino = this.listDestinoOriginal;
      }
    } else {
      this.listDestino = this.listDestinoOriginal;
    }
  }

  async getListGeneration(): Promise<void> {
    await this.formularioService
      .getListGeneration()
      .then((response) => {
        if (response.length > 0) {
          this.listGeneration =
            this.generalService.orderByDropDownList(response);
        }
      })
      .catch(async (error: HttpErrorResponse) => {
        this.notificationService.showNotificationError(
          error,
          '',
          TypeMessage.ListErrorGeneration
        );
      });
  }

  getArea = () => {
    this.route.paramMap.subscribe((paramMap) => {
      this.area = paramMap.get('area');
    });
  };

  enableInputs = () => {
    switch (this.area) {
      case eAreaType.basic:
        this.formulario.controls.basic.enable();
        //this.formulario.controls.generation_id.enable();
        this.formulario.controls.porcentagem_falha.enable();
        this.formulario.controls.vazao.enable();
        this.formulario.controls.responsavel_especial.enable();
        break;
    }
  };

  getHibridoDropdown = async () => {
    if (this.area !== eAreaType.basic) {
      await this.getListHibrido();
    } else {
      await this.getListHibridoCDR();
    }
  };

  async getListHibridoCDR(): Promise<void> {
    await this.formularioService
      .getListHibridoDropdown()
      .then((res) => {
        this.listHibrido = res;
      })
      .catch(async (error: HttpErrorResponse) => {
        this.notificationService.showNotificationError(
          error,
          '',
          TypeMessage.ListErrorHibrido
        );
      });
  }

  getDropdownPeneira = async () => {
    switch (this.area) {
      case eAreaType.basic:
        await this.getListPeneiraBasic();
        break;
      default:
        await this.getListPeneira();
        break;
    }
  };

  getDropDownProcesso = async () => {
    switch (this.area) {
      case eAreaType.basic:
        await this.getListProcessoBasic();
        break;

      default:
        await this.getListProcesso();
        break;
    }
  };

  generationChange = (event: MatSelectChange) => {
    this.generationChoose.emit(event.value);
  }

  getPc003Data() {
    // const contratoJuridico = this.formulario.get('contrato_juridico')?.value.trim()?.toUpperCase() as string;
    const safra = this.formulario.controls.safra.value

    const numeroCampo = this.formulario.controls.numero_campo.value
    // if (contratoJuridico != '' && contratoJuridico != null) {
    //     this.objPC003.emit(contratoJuridico)
    // }
    // else
    if ((safra != '' && safra != null) && (numeroCampo != '' && numeroCampo != null)) {
      this.objPC003.emit({ contratoJuridico: null, safra, numeroCampo })
      this.getListLoteDs(safra, numeroCampo)
    }
  }
  changePeneira() {
    const processo = this.formulario.get("processo_basica").value as string;
    const peneira = this.formulario.get("peneira_basica").value as string;
    if (processo != null) {

      if (processo.toUpperCase() != ("Trieur").toUpperCase()) {
        this.listPeneira = this.listPeneiraBrutaOriginal

      }
      else {
        this.listPeneira = this.listPeneiraOriginal
      }
      if (this.listPeneira.filter(p => p.name === peneira).length == 0) {
        this.formulario.get("peneira_basica").setValue(null)
      }
    }

  }

  async getListTurno(): Promise<void> {
    await this.formularioService.getListDropDownList('cd001_repasse', 'turno').pipe(take(1)).toPromise().then(response => {
      if (!!response?.data) {
        this.listTurno = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
        this.listTurnoOriginal = this.listTurno;
      }
    }).catch(async (error: HttpErrorResponse) => {
      this.notificationService.showNotificationError(error, '', TypeMessage.ListErrorTurno);
    });
  }

  async createFilterLinhaReprocessamento(value?: string): Promise<void> {
    if (!!value && value.length > 0) {
      if (this.listLinhaReprocessamentoOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase())).length > 0) {
        this.listLinhaReprocessamento = this.listLinhaReprocessamentoOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase()));
      } else {
        this.listLinhaReprocessamento = this.listLinhaReprocessamentoOriginal;
      }
    } else {
      this.listLinhaReprocessamento = this.listLinhaReprocessamentoOriginal;
    }
  }

  async createFilterTurno(value?: string): Promise<void> {
    if (!!value && value.length > 0) {
      if (this.listTurnoOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase())).length > 0) {
        this.listTurno = this.listTurnoOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase()));
      } else {
        this.listTurno = this.listTurnoOriginal;
      }
    } else {
      this.listTurno = this.listTurnoOriginal;
    }
  }

}
